const es = {
	confirmPassword: "Repita sua senha corretamente",
	min: "Não pode ser menor que $constraint1",
	max: "Não pode ser maior que $constraint1",
	isNotEmpty: "Não pode ser vazio",
	minDate: "A data mínima é $constraint1",
	maxDate: "A data máxima é $constraint1",
	isEmail: "Deve ser um e-mail válido",
	minLength: "Deve ter pelo menos $constraint1 caracteres",
	maxLength: "Não deve ter mais de $constraint1 caracteres",
	get length() {
		return (args: any) => {
			if (!args.value || args.value.length < args.constraints[0]) {
				return this.minLength;
			}
			return "Não deve ter mais de $constraint2 caracteres";
		};
	},
	isBrPhone: "Deve ser um telefone brasileiro válido",
	isCPF: "Deve ser um CPF válido",
	isUuid: "Arquivo inválido",
	isEnum: "Escolha uma das opções",
	isDate: "Deve ser uma data válida",
};

export default es;
